<template>
    <div class="phy_wrap">
       <new-text :text="text"></new-text>
       <div class="phy_top">
            <div class="title">免疫风险等级</div>
            <LevelBar class="risk-status" :active-index="list.diabetes_level"/>
            <div class="common_title" style="margin-left:16px">并发症风险</div>
            <echarts-bar :barlist="list.complication"></echarts-bar>
            <div class="common_title" style="margin-left:16px">修复能力</div>
            <echarts-bar1 :min="-100" :max="100" :barlist="list.repair"></echarts-bar1>
       </div>
       <div class="phy_cont">
        <div class="physiology" v-for="(desc,index) in list.descArr" :key="index">{{desc}}</div>
      </div>
    </div>
</template>
<script>
import EchartsBar from '@/components/EchartsBarTnb'
import EchartsBar1 from '@/components/EchartsBarTnbXf'
import lineAndBar from "@/components/lineAndBar"
import LevelBar from "./LevelBar"
import NewText from "./NewText"
export default {
    props:[ 'list' ],
    components:{ EchartsBar ,EchartsBar1, lineAndBar, NewText, LevelBar },
    data(){
      return{
        text: '除遗传因素外，不良的饮食习惯、作息习惯、缺乏运动、压力失衡等都会导致免疫力下降，并最终影响机体糖代谢发生紊乱，防治糖尿病并发症的关键是尽早地发现糖尿病，尽可能地控制和纠正患者的高血糖、高血压、血脂紊乱、肥胖以及吸烟等导致并发症的危险因素。'
      }
    }
}
</script>
<style lang="scss" scoped>
.phy_wrap{
    width: 700px;
    margin: auto;
}
.phy_top{
  width: 100%;
  background-color: #fff;
  text-align: center;
  font-size: 30px;
  min-height: 600px;
  padding-top: 30px;
  .risk_sc{
    font-size: 46px;
    color: #DD1008;
  }
  p{
    margin: 30px 0 0px;
  }
}
.phy_cont{
  padding:40px 16px;
  background-color: #fff;
  font-size: 32px;
  color: #616161;
  line-height: 36px;
  margin:40px 0;
  text-align: left;
  .common_title{
    font-size: 32px;
    color: #616161;
    margin: 30px 0 25px;
    text-align: left;
    font-weight: bold;
  }
  .physiology{
    padding: 10px 0;
    span{
      font-size: 32px;
      font-weight: bold;
      color: #2E94E5;
    }
  }
}
.risk-status{
  margin:15px auto 0;
  width:350px ;
}
</style>